export default __webpack_public_path__ + "static/3-94bb7d1dcd920c06bb9b0a7f57bf4bc9.jpg";